export default class ReturnUrl {
  static PROPERTY_NAME = 'returnUrl'

  static get isExists():boolean {
    return localStorage && localStorage.getItem(this.PROPERTY_NAME) !== null
  }

  static get url():string | null {
    if (localStorage) {
      return localStorage.getItem(this.PROPERTY_NAME)
    }

    return null
  }

  /**
   *
   * @param url - {String}.
   */
  static set(url:string):void {
    localStorage && localStorage.setItem(this.PROPERTY_NAME, url)
  }

  static delete():void {
    localStorage && localStorage.removeItem(this.PROPERTY_NAME)
  }

  static go():void {
    if (this.isExists) {
      location.href = this.url as string
      this.delete()
    } else {
      console.error('Return Url doesn`t exists')
    }
  }

  static buildFullLink(path:string):string {
      return window.location.origin + path
  }
}
